// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"DynamicPagesList_contentWrapper__3B1Lm","upperLine":"DynamicPagesList_upperLine__3rbUa","items":"DynamicPagesList_items__J1rBM"};